import { render } from "./invoice-frequency.vue?vue&type=template&id=427470b2"
import script from "./invoice-frequency.vue?vue&type=script&lang=js"
export * from "./invoice-frequency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__